import React from 'react';
import { LuMoon, LuSun } from 'react-icons/lu';
import { useAdminTheme } from '../context/AdminThemeContext';

const activeClass =
  'bg-white text-slate-900 shadow-[0_1px_4px_rgba(15,23,42,0.08)] dark:bg-[#1a2332] dark:text-primary';
const inactiveClass = 'text-slate-400 hover:text-slate-600 dark:text-gray-500 dark:hover:text-gray-300';

const AdminThemeToggle = ({ className = '' }) => {
  const { isDark, setTheme } = useAdminTheme();

  return (
    <div
      className={`inline-flex h-11 items-center gap-0.5 rounded-full border border-slate-200/60 bg-[#eef1f7]/90 p-1 dark:border-white/10 dark:bg-white/5 ${className}`}
    >
      <button
        type="button"
        onClick={() => setTheme('light')}
        aria-label="Light mode"
        aria-pressed={!isDark}
        className={[
          'inline-flex h-9 w-9 items-center justify-center rounded-full transition-all',
          !isDark ? activeClass : inactiveClass,
        ].join(' ')}
      >
        <LuSun size={17} strokeWidth={1.75} />
      </button>
      <button
        type="button"
        onClick={() => setTheme('dark')}
        aria-label="Dark mode"
        aria-pressed={isDark}
        className={[
          'inline-flex h-9 w-9 items-center justify-center rounded-full transition-all',
          isDark ? activeClass : inactiveClass,
        ].join(' ')}
      >
        <LuMoon size={17} strokeWidth={1.75} />
      </button>
    </div>
  );
};

export default AdminThemeToggle;
